import { arrInvalid } from "../../helper";

export function fitlerOptions(options, search) {
    if (arrInvalid(options)) return [];

    const res = [];
    const searchReg = new RegExp(search, "gi");
    try {
        for (let opt of options) {
            if (!opt || !opt.label) continue;

            if (!opt.label.match(searchReg)) continue;
            res.push(opt);
        }
    } catch {}

    return res;
}
